import { State } from "@/stores/product/type.ts";

export default (): State => ({
  products: [],
  count: 0,
  editedOrderProductList: {},
  productTags: [],
});
